import { lazy } from 'react';

import { array, option } from '@code-expert/prelude';
import { questionIdEq } from '/imports/modules/Quizzes/domain';
import { concatRoutes } from '/imports/modules/Routing';
import { quizNavSelectionAdt } from '../../shared/presentation/navigation';
import { manageQuizApi } from './ManageQuizApi';
import { editQuestionLink, editQuestionRoute, editQuizLink, editQuizRoute } from './routes';

const QuizPage = lazy(async () => {
  const { QuizPage } = await import('./QuizPage');
  return { default: QuizPage };
});

const EditQuestion = lazy(async () => {
  const { EditQuestion } = await import('./EditQuestion');
  return { default: EditQuestion };
});

const EditQuiz = lazy(async () => {
  const { EditQuiz } = await import('./EditQuiz');
  return { default: EditQuiz };
});

export const manageQuizRouter = concatRoutes([
  editQuestionRoute.parser.map(({ taskId, questionId, snapshot }) => (
    <QuizPage
      api={manageQuizApi}
      taskId={taskId}
      snapshotId={option.fromNullable(snapshot)}
      snapshotLink={(snapshotId) => editQuestionLink({ taskId, questionId, snapshotId })}
      selection={quizNavSelectionAdt.question(questionId)}
    >
      {({ quiz: { questionIds } }) => (
        <EditQuestion
          api={manageQuizApi}
          taskId={taskId}
          questionId={questionId}
          snapshotId={option.fromNullable(snapshot)}
          hasQuestion={array.elemV(questionIdEq)(questionIds)}
        />
      )}
    </QuizPage>
  )),
  editQuizRoute.parser.map(({ taskId, snapshot }) => (
    <QuizPage
      api={manageQuizApi}
      taskId={taskId}
      snapshotId={option.fromNullable(snapshot)}
      snapshotLink={(snapshotId) => editQuizLink({ taskId, snapshotId })}
      selection={quizNavSelectionAdt.quiz()}
    >
      {({ taskName, quiz }) => (
        <EditQuiz
          api={manageQuizApi}
          taskName={taskName}
          taskId={taskId}
          snapshotId={option.fromNullable(snapshot)}
          quiz={quiz}
        />
      )}
    </QuizPage>
  )),
]);
